import { markRaw } from 'vue'

// Polling that stands in for the stream: it runs while wanted, not
// paused, and the stream is down. When the stream comes back, catchUp
// fetches what came meanwhile: after a drop (the default), or on every
// connect ('connect', for data that has no cursor to page from).
//
// start and stop begin and end the actual poll (a fetcher, an interval).
export const createStreamedPoller = ({
  start,
  stop,
  catchUp,
  catchUpOn = 'drop',
}) => {
  const state = {
    wanted: false,
    paused: false,
    streaming: false,
    dropped: false,
    polling: false,
  }

  // one place decides, so no call can leave it running twice or not at all
  const sync = () => {
    const should = state.wanted && !state.paused && !state.streaming
    if (should && !state.polling) {
      state.polling = true
      start()
    } else if (!should && state.polling) {
      state.polling = false
      stop()
    }
  }

  return {
    get polling() {
      return state.polling
    },
    want(wanted) {
      state.wanted = wanted
      sync()
    },
    pause() {
      state.paused = true
      sync()
    },
    resume() {
      state.paused = false
      sync()
    },
    streamUp() {
      state.streaming = true
      sync()
      const missed = catchUpOn === 'connect' || state.dropped
      state.dropped = false
      if (missed && state.wanted) catchUp()
    },
    streamDown() {
      state.streaming = false
      state.dropped = true
      sync()
    },
  }
}

// a timeline or the notifications: the poll is the holder's fetcher at the
// time of the call. Made on first use and kept out of reactivity.
export const fetcherPoller = (holder) => {
  holder.poller ??= markRaw(
    createStreamedPoller({
      start: () => holder.fetcher?.startFetching(),
      stop: () => holder.fetcher?.stopFetching(),
      catchUp: () => holder.fetcher?.fetchNewer(),
    }),
  )
  return holder.poller
}
